import * as React from 'react'
import * as R from 'ramda'
import {OfferTab, PositionRow} from './OfferState'
import {OfferAction} from './OfferActions'
import Table from 'material-ui/Table/Table'
import TableHeaderColumn from 'material-ui/Table/TableHeaderColumn'
import TableRow from 'material-ui/Table/TableRow'
import TableHeader from 'material-ui/Table/TableHeader'
import TableBody from 'material-ui/Table/TableBody'
import TableRowColumn from 'material-ui/Table/TableRowColumn'
import TextField from 'material-ui/TextField'
import {Downloadable} from '../../../Data/Downloadable'
import FileAttachment from 'material-ui/svg-icons/file/attachment'
import CircularProgress from 'material-ui/CircularProgress'
import AlertError from 'material-ui/svg-icons/alert/error'
import Card from 'material-ui/Card/Card'
import {IconButton, TouchTapEvent} from 'material-ui'
import * as Editable from '../../../Data/Editable'
import {EditableFloatingActionButtons} from '../../../View/EditableFloatingActionButtons'
import Popover from 'material-ui/Popover/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import ContentSend from 'material-ui/svg-icons/content/send'
import Snackbar from 'material-ui/Snackbar'
import {Actionable} from '../../../Data/Actionable'
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh'
import Dialog from 'material-ui/Dialog'
import {Offer} from '../../../Entities/Offer'
import ListItem from 'material-ui/List/ListItem'
import List from 'material-ui/List/List'
import FileDownload from 'material-ui/svg-icons/file/file-download'
import {errorMessage} from '../../../Data/FormValidation'
import ContentUndo from 'material-ui/svg-icons/content/undo'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import AddIcon from 'material-ui/svg-icons/content/add-box'
import {black, darkBlack, grey300} from 'material-ui/styles/colors'
import ContentLink from 'material-ui/svg-icons/content/link'
import TableFooter from 'material-ui/Table/TableFooter'
import {Totals} from '../../../Entities/Totals'
import {InquiryOfferStatus} from '../../../Entities/InquiryOfferStatus'
import {formatPrice} from '../../../Data/NumberHelper'
import {ProductFinderView} from '../../../Components/ProductFinder/ProductFinderView'
import LinkOff from 'mdi-material-ui/LinkOff'
import Button from 'material-ui-next/Button'
import {generalStyles} from '../../../Style'
import injectSheet from 'react-jss'
import {WithClasses} from '../../../View/Helper'
import {minuteDateTimeFormatter} from '../../../View/Utils'

export function OfferView({active, state, dispatch, totals, isForBalke}: {
    active: boolean,
    state: OfferTab,
    dispatch: (action: OfferAction) => void,
    totals: Totals,
    isForBalke: boolean
}) {
    return (
        <div>
            {state.productFinding !== null &&
            <ProductFinderView
                state={state.productFinding.productFinderState}
                dispatch={
                    subAction => dispatch({
                        type: 'ProductFinderModuleAction',
                        subAction,
                    })
                }
            />
            }
            {active &&
            <EditableFloatingActionButtons
                editable={state.editable}
                onEdit={() => dispatch({
                    type: 'Edit',
                })}
                onSave={() => dispatch({
                    type: 'Save',
                })}
                onDiscard={() => dispatch({
                    type: 'Discard',
                })}
                disabled={
                    isForBalke && state.inquiry.offerStatus !== 'requested'
                }
            />
            }
            {active && state.editable.type === 'Locked' &&
            <CreateOfferButton
                error={
                    offerDisabledLabel(state.inquiry.offerStatus)
                }
                actionable={state.createOfferActionable}
                dispatch={dispatch}
            />
            }
            <Snackbar
                message="Angebot wurde versendet"
                open={state.offerCreatedToastOpen}
                onRequestClose={() => dispatch({
                    type: 'CloseOfferCreatedToast',
                })}
                autoHideDuration={3000}
            />
            <CreateOfferDialog
                dispatch={dispatch}
                open={state.offerCreationDialogOpen}
                offerCreationComment={state.offerCreationComment}
            />
            <div
                className="row"
            >
                <div
                    className="column column__details"
                >
                    <div className="row">
                        <div className="column">
                            <OfferAddressView
                                state={state}
                                dispatch={dispatch}
                            />
                        </div>
                        <div className="column">
                            <Card
                                className="tab__form-card"
                            >
                                <div className="tab__form-header">
                                    <h4>Bisherige Angebote</h4>
                                </div>
                                <div className="tab__form-content">
                                    <List style={{width: '100%'}}>
                                        {R.map(
                                            (offer: Offer) => (
                                                <ListItem
                                                    innerDivStyle={{paddingLeft: '0px'}}
                                                    hoverColor="transparent"
                                                    key={offer.id}
                                                    rightIcon={<FileDownload/>}
                                                    className="offer-list__item"
                                                    primaryText={`Netto: ${formatPrice(offer.totalNetPrice)} /
                                                                € Brutto: ${formatPrice(offer.totalGrossPrice)} €`}
                                                    secondaryText={offer.created.format(minuteDateTimeFormatter())}
                                                />
                                            ),
                                            state.offers,
                                        )}
                                    </List>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>

                <div className="column column__table">
                    <Card>
                        <form noValidate={true}>
                            <Table
                                selectable={false}
                                fixedHeader={false}
                                className="inquiry-table"
                            >
                                <TableHeader
                                    displaySelectAll={false}
                                    adjustForCheckbox={false}
                                    className="inquiry-table-header"
                                >
                                    <TableRow>
                                        <TableHeaderColumn className="inquiry-table-header__name">
                                            Name
                                        </TableHeaderColumn>
                                        <TableHeaderColumn className="inquiry-table-header__references">
                                            Referenz
                                        </TableHeaderColumn>
                                        <TableHeaderColumn className="inquiry-table-header__description">
                                            Beschreibung
                                        </TableHeaderColumn>
                                        <TableHeaderColumn className="inquiry-table-header__amount">
                                            Anzahl
                                        </TableHeaderColumn>
                                        <TableHeaderColumn className="inquiry-table-header__weight">
                                            Gewicht (g)
                                        </TableHeaderColumn>
                                        <TableHeaderColumn className="inquiry-table-header__attachments">
                                            Anhänge
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            style={{textAlign: 'right'}}
                                            className="inquiry-table-header__price"
                                        >
                                            Preis (netto)
                                        </TableHeaderColumn>
                                        {(state.editable.type === 'Pending' && !isForBalke) &&
                                        <TableHeaderColumn className="inquiry-table-header__buttons">
                                            <IconButton
                                                tooltip="Position hinzufügen"
                                                tooltipPosition={'bottom-left'}
                                                onTouchTap={() => {
                                                    dispatch({
                                                        type: 'CreateNewPosition'
                                                    })
                                                }}
                                            >
                                                <AddIcon/>
                                            </IconButton>
                                        </TableHeaderColumn>
                                        }
                                    </TableRow>
                                </TableHeader>
                                <TableBody
                                    displayRowCheckbox={false}
                                    className="inquiry-table-body"
                                >
                                    {R.map(
                                        (positionRow) =>
                                            <PositionRowView
                                                key={positionRow.id}
                                                editable={state.editable}
                                                positionRow={positionRow}
                                                dispatch={dispatch}
                                                isForBalke={isForBalke}
                                            />,
                                        R.filter(
                                            (positionRow: PositionRow) =>
                                                state.editable.type !== 'Locked' || !positionRow.input.deleted
                                            , state.positionRows)
                                    )}
                                </TableBody>
                                {state.editable.type === 'Pending' &&
                                <TableFooter className="nocheckbox-footer inquiry-table-footer">
                                    <TableRow>
                                        <TableRowColumn
                                            colSpan={5}
                                            className="inquiry-table-footer__label"
                                            style={{verticalAlign: 'middle'}}
                                        >
                                            Versandkosten
                                        </TableRowColumn>
                                        <TableRowColumn className="inquiry-table-footer__value">
                                            <TextField
                                                className="truncate"
                                                style={{width: '100%'}}
                                                value={state.shippingCostsInput}
                                                onChange={(
                                                    event,
                                                    value
                                                ) => dispatch({
                                                    type: 'ShippingCostsInputChanged',
                                                    value,
                                                })}
                                                underlineDisabledStyle={{display: 'none'}}
                                                errorText={errorMessage(state.shippingCostsValidation)}
                                                id={'shipping-costs-input'}
                                            />
                                            €
                                        </TableRowColumn>
                                        <TableRowColumn className="inquiry-table-footer__empty"/>
                                    </TableRow>
                                </TableFooter>
                                }
                                {state.editable.type === 'Locked' &&
                                <TableFooter className="nocheckbox-footer inquiry-table-footer">
                                    <TableRow>
                                        <TableRowColumn
                                            colSpan={5}
                                            className="inquiry-table-footer__label"
                                        >
                                            Versandkosten
                                        </TableRowColumn>
                                        <TableRowColumn
                                            className="inquiry-table-footer__value"
                                            colSpan={2}
                                        >
                                            {state.shippingCostsInput} €
                                        </TableRowColumn>
                                    </TableRow>
                                    <TableRow>
                                        <TableRowColumn
                                            colSpan={5}
                                            className="inquiry-table-footer__label"
                                        >
                                            Nettopreis
                                        </TableRowColumn>
                                        <TableRowColumn
                                            className="inquiry-table-footer__value"
                                            colSpan={2}
                                        >
                                            {formatPrice(totals.netPrice)} €
                                        </TableRowColumn>
                                    </TableRow>
                                    {R.map(
                                        vat => (
                                            <TableRow key={vat.percentage}>
                                                <TableRowColumn
                                                    colSpan={5}
                                                    className="inquiry-table-footer__label"
                                                >
                                                    UST ({vat.percentage}%)
                                                </TableRowColumn>
                                                <TableRowColumn
                                                    className="inquiry-table-footer__value"
                                                    colSpan={2}
                                                >
                                                    {formatPrice(vat.price)} €
                                                </TableRowColumn>
                                            </TableRow>
                                        ),
                                        totals.vats,
                                    )}
                                    <TableRow className="inquiry-table-footer__total-amount">
                                        <TableRowColumn
                                            colSpan={5}
                                            className="inquiry-table-footer__label"
                                        >
                                            Endbetrag
                                        </TableRowColumn>
                                        <TableRowColumn
                                            className="inquiry-table-footer__value"
                                            colSpan={2}
                                        >
                                            {formatPrice(totals.grossPrice)} €
                                        </TableRowColumn>
                                    </TableRow>
                                </TableFooter>
                                }

                            </Table>

                        </form>
                    </Card>
                </div>
            </div>
        </div>
    )
}

function offerDisabledLabel(offerStatus: InquiryOfferStatus): string {
    switch (offerStatus) {
        case 'approved':
            return 'Das Angebot wurde bereits angenommen!'
        case 'discarded':
            return 'Die Anfrage wurde verworfen!'
        case 'inApproval':
            return 'Ein neues Angebot wurde bereits formuliert und liegt dem Kunden vor!'
        default:
            return ''
    }
}

function CreateOfferDialog({dispatch, open, offerCreationComment}: {
    dispatch: (action: OfferAction) => void,
    open: boolean
    offerCreationComment: string
}) {
    const createOfferActions = [
        (
            <FlatButton
                label="Abbrechen"
                primary={true}
                onTouchTap={() => {
                    dispatch({type: 'ToogleOfferCreationDialog', open: false})
                }}
            />
        ),
        (
            <FlatButton
                label="Angebot versenden"
                primary={true}
                keyboardFocused={true}
                onTouchTap={() => dispatch({type: 'CreateOffer'})}
            />
        ),
    ]
    return (
        <Dialog
            title="Neues Angebot erstellen!"
            modal={false}
            open={open}
            actions={createOfferActions}
            onRequestClose={() => {
                dispatch({type: 'ToogleOfferCreationDialog', open: false})
            }}
        >
            <TextField
                fullWidth={true}
                floatingLabelText={'Kommentar'}
                multiLine={true}
                value={offerCreationComment}
                rows={1}
                rowsMax={6}
                onChange={(event, value) => dispatch({
                    type: 'ChangedOfferCreationComment',
                    value: value
                })}
            />
        </Dialog>
    )
}

const createOfferButtonStyles = {
    fab: {
        ...generalStyles.fab,
        ...generalStyles.secondaryFab,
    },
    tooltip: {
        position: 'fixed',
        bottom: '130px',
        right: '100px',
    },
}

interface CreateOfferButtonProperties {
    readonly dispatch: (action: OfferAction) => void,
    readonly actionable: Actionable,
    readonly error: string,
}

const CreateOfferButton =
    injectSheet<CreateOfferButtonProperties>(createOfferButtonStyles)(
        ({dispatch, actionable, error, classes}: WithClasses<CreateOfferButtonProperties>) => {
            switch (actionable.type) {
                case 'Default':
                    return (
                        <div>
                            <div className={classes.tooltip}>{error}</div>
                            <Button
                                fab={true}
                                disabled={error !== ''}
                                className={classes.fab}
                                onClick={() => {
                                    dispatch({
                                        type: 'ToogleOfferCreationDialog',
                                        open: true
                                    })
                                }}
                            >
                                <ContentSend/>
                            </Button>
                        </div>
                    )
                case 'Loading':
                    return (
                        <Button
                            fab={true}
                            className={classes.fab}
                            disabled={true}
                        >
                            <CircularProgress size={24}/>
                        </Button>
                    )
                case 'Failure':
                    return (
                        <Button
                            fab={true}
                            className={classes.fab}
                            onClick={() => dispatch({type: 'CreateOffer'})}
                        >
                            <NavigationRefresh/>
                        </Button>
                    )
            }
        }
    )

function PositionRowView({editable, positionRow, dispatch, isForBalke}: {
    editable: Editable.Editable<null>,
    positionRow: PositionRow,
    dispatch: (action: OfferAction) => void,
    isForBalke: boolean
}) {
    const
        {id, inquiryPositionWithDetails, input, validation} = positionRow,
        disabled = Editable.inputsDisabled(editable) || input.deleted,
        inputStyle = (input.deleted) ? {color: grey300} : {color: black},
        notes = (inquiryPositionWithDetails !== null) ? inquiryPositionWithDetails.inquiryPosition.notes : '',
        priceColor = (input.deleted) ? grey300 : darkBlack
    return (
        <TableRow>
            <TableRowColumn className="inquiry-table-body__name">
                <TextField
                    className="truncate"
                    style={{width: '100%'}}
                    disabled={disabled}
                    value={input.name}
                    onChange={(event, value) => dispatch({
                        type: 'PositionNameChanged',
                        id: positionRow.id,
                        value,
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={inputStyle}
                    errorText={errorMessage(validation.name)}
                    id={`name-input-${id}`}
                />
            </TableRowColumn>
            <TableRowColumn className="inquiry-table-body__reference">
                {input.product !== null ?
                    (editable.type === 'Locked' ?
                            input.product.externalProductId :
                            <span style={{color: priceColor}}>
                                Produkt<br/>{input.product.externalProductId}
                                <IconButton
                                    tooltip={'Referenz entfernen'}
                                    tooltipPosition={'bottom-left'}
                                    onTouchTap={() => dispatch({
                                        type: 'RemoveReference',
                                        id: positionRow.id,
                                    })}
                                >
                                    <LinkOff/>
                                </IconButton>
                            </span>
                    ) :
                    (editable.type === 'Locked' ?
                        <em style={{color: priceColor}}>keine</em> :
                        <FlatButton
                            label="Verknüpfen"
                            icon={<ContentLink/>}
                            onTouchTap={() => dispatch({
                                type: 'OpenProductFinder',
                                id: positionRow.id
                            })}
                            fullWidth={true}
                            disabled={input.deleted}
                        />)}
            </TableRowColumn>
            <TableRowColumn className="inquiry-table-body__description">
                <span style={inputStyle}>{notes}</span>
            </TableRowColumn>
            <TableRowColumn className="inquiry-table-body__amount">
                <TextField
                    style={{width: '100%'}}
                    disabled={disabled}
                    value={input.amount}
                    onChange={(event, value) => dispatch({
                        type: 'PositionAmountChanged',
                        id: positionRow.id,
                        value,
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={inputStyle}
                    errorText={errorMessage(validation.amount)}
                    id={`amount-input-${id}`}
                />
            </TableRowColumn>
            <TableRowColumn className="inquiry-table-body__weight">
                <TextField
                    disabled={disabled}
                    value={input.weight}
                    onChange={(event, value) => dispatch({
                        type: 'PositionWeightChanged',
                        id: positionRow.id,
                        value,
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={inputStyle}
                    errorText={errorMessage(validation.weight)}
                    id={`weight-input-${id}`}
                />
            </TableRowColumn>
            <TableRowColumn className="inquiry-table-body__attachments">
                <AttachmentsView
                    positionRow={positionRow}
                    dispatch={dispatch}
                />
            </TableRowColumn>
            <TableRowColumn className="inquiry-table-body__price">
                <div
                    style={{
                        position: 'relative',
                        textAlign: ' right',
                        top: '1.6em',
                        color: priceColor
                    }}
                >
                    €
                </div>
                <div
                    style={{
                        paddingRight: '15px',
                        boxSizing: 'border-box',
                        width: '100%',
                        marginTop: '-0.7em'
                    }}
                >
                    <TextField
                        disabled={disabled}
                        value={input.price}
                        onChange={(event, value) => dispatch({
                            type: 'PositionPriceChanged',
                            id: positionRow.id,
                            value,
                        })}
                        underlineDisabledStyle={{display: 'none'}}
                        inputStyle={inputStyle}
                        errorText={errorMessage(validation.price)}
                        id={`price-input-${id}`}
                    />
                </div>
            </TableRowColumn>
            {(editable.type === 'Pending' && !isForBalke) &&
            <TableRowColumn className="inquiry-table-body__buttons">
                <IconButton
                    onTouchTap={() => dispatch({
                        type: 'OfferPositionToBeDeletedToggle',
                        id: positionRow.id,
                        deleted: !input.deleted
                    })}
                >
                    {input.deleted ?
                        <ContentUndo/> :
                        <ActionDelete/>}
                </IconButton>
            </TableRowColumn>
            }
        </TableRow>
    )
}

interface AttachmentsViewProps {
    readonly positionRow: PositionRow
    readonly dispatch: (action: OfferAction) => void
}

class AttachmentsView
    extends React.Component<AttachmentsViewProps, { attachmentsPopoverAnchorElement?: HTMLElement }> {
    constructor(props: AttachmentsViewProps) {
        super(props)
        this.state = {}
    }

    render() {
        const
            {positionRow, dispatch} = this.props,
            {attachmentRows} = positionRow
        return attachmentRows.length > 0 && (
            <div>

                <FlatButton
                    onTouchTap={(event: TouchTapEvent) => {
                        this.setState({
                            attachmentsPopoverAnchorElement:
                                event.currentTarget as HTMLElement,
                        })
                        dispatch({
                            type: 'AttachmentsPopoverToggle',
                            id: positionRow.id,
                            open: true,
                        })
                    }}
                    label={
                        attachmentRows.length === 1
                            ? '1 Anhang'
                            : `${attachmentRows.length}`}
                    icon={<FileAttachment/>}
                />
                <Popover
                    open={positionRow.attachmentsPopoverOpen}
                    anchorEl={this.state.attachmentsPopoverAnchorElement}
                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    onRequestClose={() => dispatch({
                        type: 'AttachmentsPopoverToggle',
                        id: positionRow.id,
                        open: false,
                    })}
                >
                    <Menu>
                        {R.map(
                            ({inquiryPositionAttachment, download}) =>
                                <MenuItem
                                    key={inquiryPositionAttachment.id}
                                    onTouchTap={() => dispatch({
                                        type: 'DownloadInquiryPositionAttachment',
                                        inquiryPositionAttachment,
                                    })}
                                >
                                    {inquiryPositionAttachment.filename}
                                    <AttachmentDownloadIcon
                                        download={download}
                                    />
                                </MenuItem>,
                            positionRow.attachmentRows,
                        )}
                    </Menu>
                </Popover>
            </div>
        )
    }
}

function AttachmentDownloadIcon({download}: { download: Downloadable }) {
    switch (download.type) {
        case 'Default':
            return null
        case 'Loading':
            return <CircularProgress size={24}/>
        case 'Failure':
            return <AlertError/>
    }
}

function OfferAddressView({state, dispatch}: {
    state: OfferTab,
    dispatch: (action: OfferAction) => void,
}) {
    const
        disabled = Editable.inputsDisabled(state.editable),
        input = state.inquiryInput
    return (
        <Card className="tab__form-card">
            <div className="tab__form-header">
                <h4>Angebotsaddresse</h4>
            </div>
            <TextField
                floatingLabelText="Name 1"
                disabled={disabled}
                value={input.offerName1}
                onChange={(event, value) => dispatch({
                    type: 'InquiryInputChanged',
                    changes: {offerName1: value},
                })}
                underlineDisabledStyle={{display: 'none'}}
                inputStyle={{color: 'black'}}
                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                floatingLabelShrinkStyle={{color: 'black'}}
                fullWidth={true}
            />
            <TextField
                floatingLabelText="Name 2"
                disabled={disabled}
                value={input.offerName2}
                onChange={(event, value) => dispatch({
                    type: 'InquiryInputChanged',
                    changes: {offerName2: value},
                })}
                underlineDisabledStyle={{display: 'none'}}
                inputStyle={{color: 'black'}}
                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                floatingLabelShrinkStyle={{color: 'black'}}
                fullWidth={true}
            />
            <div style={{display: 'flex'}}>
                <TextField
                    floatingLabelText="Straße"
                    disabled={disabled}
                    value={input.offerStreet}
                    onChange={(event, value) => dispatch({
                        type: 'InquiryInputChanged',
                        changes: {offerStreet: value},
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    style={{flex: '1'}}
                />
                <div style={{flex: 'none', width: '8px'}}/>
                <TextField
                    floatingLabelText="Hausnummer"
                    disabled={disabled}
                    value={input.offerHouseNumber}
                    onChange={(event, value) => dispatch({
                        type: 'InquiryInputChanged',
                        changes: {offerHouseNumber: value},
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    style={{flex: 'none', width: '96px'}}
                />
            </div>
            <div style={{display: 'flex'}}>
                <TextField
                    floatingLabelText="Postleitzahl"
                    disabled={disabled}
                    value={input.offerZipCode}
                    onChange={(event, value) => dispatch({
                        type: 'InquiryInputChanged',
                        changes: {offerZipCode: value},
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    style={{flex: 'none', width: '96px'}}
                />
                <div style={{flex: 'none', width: '8px'}}/>
                <TextField
                    floatingLabelText="Stadt"
                    disabled={disabled}
                    value={input.offerCity}
                    onChange={(event, value) => dispatch({
                        type: 'InquiryInputChanged',
                        changes: {offerCity: value},
                    })}
                    underlineDisabledStyle={{display: 'none'}}
                    inputStyle={{color: 'black'}}
                    floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                    floatingLabelShrinkStyle={{color: 'black'}}
                    style={{flex: '1'}}
                />
            </div>
            <TextField
                floatingLabelText="Land"
                disabled={disabled}
                value={input.offerCountry}
                onChange={(event, value) => dispatch({
                    type: 'InquiryInputChanged',
                    changes: {offerCountry: value},
                })}
                underlineDisabledStyle={{display: 'none'}}
                inputStyle={{color: 'black'}}
                floatingLabelStyle={{color: 'rgba(0, 0, 0, 0.3)'}}
                floatingLabelShrinkStyle={{color: 'black'}}
                fullWidth={true}
            />
        </Card>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryDetails/Offer/OfferView.tsx